import { useState } from "react";
import { Download, Trash2, ShieldCheck } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { toast } from "sonner";

export function RgpdPanel() {
  const { logout } = useAuth();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const doExport = async () => {
    try {
      const { data } = await api.exportData();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = "mes-donnees-guidance-celeste.json"; a.click();
      URL.revokeObjectURL(url);
      toast.success("Vos données ont été exportées.");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const doDelete = async () => {
    try {
      await api.deleteAccount();
      toast.success("Compte et données supprimés.");
      await logout();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="glass rounded-3xl border border-celeste-or/15 p-6" data-testid="rgpd-panel">
      <h3 className="flex items-center gap-2 font-serif text-lg text-celeste-ivoire"><ShieldCheck className="h-5 w-5 text-celeste-or" /> Mes données (RGPD)</h3>
      <p className="mt-2 text-sm text-celeste-lilas/75">Conformément au RGPD, vous pouvez exporter l'ensemble de vos données ou supprimer définitivement votre compte.</p>
      <div className="mt-4 flex flex-wrap gap-3">
        <Button data-testid="rgpd-export-btn" onClick={doExport} variant="ghost" className="border border-celeste-violet/30 text-celeste-lilas hover:bg-celeste-violet/15">
          <Download className="mr-1.5 h-4 w-4" /> Exporter mes données
        </Button>
        <Button data-testid="rgpd-delete-btn" onClick={() => setConfirmOpen(true)} variant="ghost" className="border border-red-400/40 text-red-200 hover:bg-red-500/10">
          <Trash2 className="mr-1.5 h-4 w-4" /> Supprimer mon compte
        </Button>
      </div>

      <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <DialogContent className="glass-strong text-celeste-ivoire border-red-400/25" data-testid="rgpd-delete-dialog">
          <DialogHeader><DialogTitle className="font-serif text-red-200">Supprimer définitivement votre compte ?</DialogTitle></DialogHeader>
          <p className="text-sm text-celeste-lilas/80">Cette action est irréversible. Vos données personnelles, portefeuille, favoris, rendez-vous et avis seront supprimés.</p>
          <DialogFooter>
            <Button variant="ghost" className="border border-celeste-violet/30 text-celeste-lilas" onClick={() => setConfirmOpen(false)}>Annuler</Button>
            <Button data-testid="rgpd-confirm-delete" onClick={doDelete} className="bg-red-500 text-white hover:bg-red-600">Supprimer définitivement</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
